var map = {
	"./_base-dropdown.vue": "ded6",
	"./_base-modal.vue": "17b1",
	"./_base-pagination.vue": "6ce0",
	"./_base-select.vue": "1a4c",
	"./_base-tab.vue": "a244",
	"./_base-table.vue": "2c4a",
	"./_base-tabs.vue": "e9dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33a6";